import vademecumService from "../../../services/vademecum/Vademecum.js";
export default {
  data() {
    return {
      controlledMedicine: false,
      applicableMedicine: false,
      spoiledMedicine: false,
      search: "",
      isApplicable: false,
      isFeatured: false,
      isWatched: false,
      vademecumData: [],
      listVademecum: [],
      rowsPerPageItems: [5, 10, 15, 20],
      headers: [
        {
          text: "PLU",
          sortable: false,
          value: "plu"
        },
        {
          sortable: false,
          text: i18n.t('headers.name'),
          value: "name"
        },
        {
          sortable: false,
          text: "Controlados",
          value: "isWatched",
          align: "left"
        },
        {
          sortable: false,
          text: "Aplicados",
          value: "isApplicable",
          align: "left"
        },
        {
          sortable: false,
          text: "Consentido",
          value: "isFeatured",
          align: "left"
        }
      ],
      itemsData: [
        {
          plu: "213213",
          description: "Acetaminofen",
          count: 12,
          nextShippingDate: " 2018-07-07",
          name: "NANCY COMPLEJO",
          identification: "39448156"
        }
      ]
    };
  },
  props: {
    getDataVademecum: {
      type: Array,
      default: () => []
    }
  },
  watch: {},
  created() {
    this.getVademecum();
  },
  methods: {
    onRowClick(item) {
      this.$emit("row-click", item);
    },
    dataChange(item) {
      this.listVademecum.push(item);
      for (var i = 0; i < this.listVademecum.length; i++) {
        if (this.listVademecum[i].plu == item.plu) {
          this.listVademecum = this.listVademecum.filter(
            plu => plu.plu !== item.plu
          );
          this.listVademecum.splice(item.plu, 1, item);
        }
      }
    },
    getVademecum() {
      vademecumService.getVademecum().then(response => {
        this.vademecumData = response.data;
        return this.vademecumData;
      });
    },

    sendVademecum() {
      vademecumService
        .updateVademecumList(this.listVademecum)
        .then(response => {
          this.$notify({
            group: "app",
            type: "success",
            text: "Vademecum guardado correctamente!"
          });
          this.getVademecum();
        });
    }
  }
};
